import React, { useReducer, useContext } from "react";
import axios from "axios";
import { Form, Field } from "react-final-form";
import URL from "../../common/variables";

import UserContext from "../WelcomeUser/UserContext";
import validate, { required } from "./FormNameProfileValidations";
import { FormNameProfileReducer } from "./FormNameProfileReducer";

const FormNameProfile = ({ isUpdate = false }) => {
  const user = useContext(UserContext);
  const initialState = {
    isError: false,
    isErrorMessage: [],
  };
  const [state, dispatch] = useReducer(FormNameProfileReducer, initialState);

  const onSubmit = (values) => {
    const { username, email } = user;
    const perfil = Object.assign({}, values.perfil);

    perfil.headshot = null;

    const updateUser = {
      username,
      email,
      first_name: values.first_name,
      last_name: values.last_name,
      perfil,
    };

    // First create profile
    axios({
      method: isUpdate ? "put" : "post",
      url: isUpdate ? `${URL}/perfil/${user.perfil.id}/` : `${URL}/perfil/`,
      data: perfil,
    })
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return axios.put(`${URL}/user/${response.data.user}/`, updateUser);
        }
      })
      .then(() => {
        dispatch({ type: "IS_ERROR_REMOVED" });

        if (!isUpdate) {
          location.reload();
        } else {
          alert("Guardado correctamente");
        }
      })
      .catch((error) =>
        dispatch({
          type: "IS_ERROR_ACTIVE",
          message: error.response.data,
        })
      );
  };

  return (
    <div className="login">
      <Form
        onSubmit={onSubmit}
        validate={validate}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name="first_name"
              initialValue={user.first_name ? user.first_name : ""}
            >
              {({ input, meta }) => (
                <div className="mb-3">
                  <input
                    {...input}
                    autoComplete="off"
                    className="form-control rounded-0"
                    placeholder="Nombre completo"
                    type="text"
                  />
                  {meta.error && meta.touched && (
                    <div className="mt-1 mb-4 text-danger">
                      <small>{meta.error}</small>
                    </div>
                  )}
                </div>
              )}
            </Field>

            <Field
              name="last_name"
              initialValue={user.last_name ? user.last_name : ""}
            >
              {({ input, meta }) => (
                <div className="mb-3">
                  <input
                    {...input}
                    autoComplete="off"
                    className="form-control rounded-0"
                    placeholder="Apellidos"
                    type="text"
                  />
                  {meta.error && meta.touched && (
                    <div className="mt-1 mb-4 text-danger">
                      <small>{meta.error}</small>
                    </div>
                  )}
                </div>
              )}
            </Field>

            <Field
              name="perfil.genero"
              initialValue={
                user.perfil && user.perfil.genero ? user.perfil.genero : ""
              }
            >
              {({ input, meta }) => (
                <div className="form-group mb-3">
                  <Field
                    {...input}
                    className="rounded-0 form-control"
                    component="select"
                    validate={required}
                  >
                    <option>Género</option>
                    <option value="M">Masculino</option>
                    <option value="0">No determinado</option>
                    <option value="F">Femenino</option>
                  </Field>
                  {meta.error && meta.touched && (
                    <div className="mt-1 mb-4 text-danger">
                      <small>{meta.error}</small>
                    </div>
                  )}
                </div>
              )}
            </Field>

            <Field
              name="perfil.fecha_nacimiento"
              initialValue={
                user.perfil && user.perfil.fecha_nacimiento
                  ? user.perfil.fecha_nacimiento
                  : ""
              }
              validate={required}
            >
              {({ input, meta }) => (
                <div className="mb-3">
                  <label>Fecha de nacimiento</label>
                  <input
                    {...input}
                    type="date"
                    className="rounded-0 form-control"
                  />
                  {meta.error && meta.touched && (
                    <div className="mt-1 mb-4 text-danger">
                      <small>{meta.error}</small>
                    </div>
                  )}
                </div>
              )}
            </Field>

            <Field
              name="perfil.codigo_postal"
              initialValue={
                user.perfil && user.perfil.codigo_postal
                  ? user.perfil.codigo_postal
                  : ""
              }
              validate={required}
            >
              {({ input, meta }) => (
                <div className="mb-3">
                  <input
                    {...input}
                    autoComplete="off"
                    className="form-control rounded-0"
                    placeholder="Código Postal"
                    type="text"
                  />
                  {meta.error && meta.touched && (
                    <div className="mt-1 mb-4 text-danger">
                      <small>{meta.error}</small>
                    </div>
                  )}
                </div>
              )}
            </Field>

            <Field
              name="perfil.colonia"
              initialValue={
                user.perfil && user.perfil.colonia ? user.perfil.colonia : ""
              }
              validate={required}
            >
              {({ input, meta }) => (
                <div className="mb-3">
                  <input
                    {...input}
                    autoComplete="off"
                    className="form-control rounded-0"
                    placeholder="Colónia"
                    type="text"
                  />
                  {meta.error && meta.touched && (
                    <div className="mt-1 mb-4 text-danger">
                      <small>{meta.error}</small>
                    </div>
                  )}
                </div>
              )}
            </Field>

            {/* Form button */}
            <button
              type="submit"
              disabled={submitting}
              className="btn btn-lg btn-block bg-warning mt-4 mb-2"
            >
              {submitting ? "Guardando..." : "Guardar"}
            </button>

            {state.isError && <showObjErrors obj={state.isErrorMessage} />}
          </form>
        )}
      />
    </div>
  );
};

export default FormNameProfile;
